import React from 'react'
import { Form, Input, Modal, Select } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '~/Store'
import {
  getIsConfirmLoading,
  getModalVisibility,
  getServicePrincipalSelected,
  ModalName,
  ServicePrincipalActions,
} from '~/Store/ServicePrincipal'
import { ServicePrincipalStatus } from '~/Services/ServicePrincipal.interface'

const { Option } = Select

export const EditServicePrincipal = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const visible = useAppSelector(getModalVisibility(ModalName.ServicePrincipal))
  const confirmLoading = useAppSelector(getIsConfirmLoading)
  const servicePrincipal = useAppSelector(getServicePrincipalSelected)
  const [form] = Form.useForm()

  const selfClose = () => {
    dispatch(ServicePrincipalActions.setServicePrincipalSelected(undefined))
    dispatch(
      ServicePrincipalActions.setModalVisibility({
        name: ModalName.ServicePrincipal,
        visible: false,
      }),
    )
  }

  const onSubmit = () => {
    form.validateFields().then(values => {
      if (servicePrincipal) {
        dispatch(
          ServicePrincipalActions.updateServicePrincipal({
            id: servicePrincipal.id,
            name: values['name'],
            status: values['status'],
          }),
        )
      } else {
        dispatch(
          ServicePrincipalActions.createServicePrincipal({
            name: values['name'],
          }),
        )
      }
    })
  }

  return (
    <Modal
      visible={visible}
      title={
        servicePrincipal
          ? t('admin.editServicePrincipal')
          : t('admin.newServicePrincipal')
      }
      confirmLoading={confirmLoading}
      onCancel={selfClose}
      onOk={onSubmit}
      okText={t('save')}
      cancelText={t('cancel')}
    >
      <Form
        form={form}
        initialValues={{
          name: servicePrincipal?.name,
          status: servicePrincipal?.status ?? ServicePrincipalStatus.Active,
        }}
        layout="vertical"
        onFinish={onSubmit}
        autoComplete="off"
      >
        <Form.Item
          label={t('admin.name')}
          name="name"
          rules={[{ required: true, message: t('fieldRequired') }]}
        >
          <Input />
        </Form.Item>
        {servicePrincipal && (
          <Form.Item label={t('admin.status')} name="status">
            <Select>
              <Option value={ServicePrincipalStatus.Active}>
                {t('admin.spStatusActive')}
              </Option>
              <Option value={ServicePrincipalStatus.Suspended}>
                {t('admin.spStatusSuspended')}
              </Option>
              <Option value={ServicePrincipalStatus.Deleted}>
                {t('admin.spStatusInactive')}
              </Option>
            </Select>
          </Form.Item>
        )}
      </Form>
    </Modal>
  )
}
